import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { GAME_DB } from '../../db/game';
import { useDispatch } from 'react-redux';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import Footer from '../Footer';
const PublicPageLayout = ({ children }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const checkIfActiveGame = async () => {
            const currentGame = await GAME_DB.GET.game();
            if (currentGame) {
                const gameStatus = await GAME_DB.GET.gameStatus();
                if (gameStatus === 'active') {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.continueActiveGame.key));
                }
                else {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.saveGameResult.key));
                }
            }
        };
        checkIfActiveGame();
    }, []);
    return (_jsxs(_Fragment, { children: [children, _jsx(Footer, { layout: "gameplay" })] }));
};
export default PublicPageLayout;
